import {CategoryTree} from '@/__generated__/__types__';
import {createLeadingSlashUrl} from '@/_application/core/utils/common';

export const getCategoryUrl = (category: CategoryTree, isAbsolute = true): string => {
    const {url_key, url_suffix, canonical_url} = category;
    let baseUrl = process.env.NEXT_PUBLIC_BASE_SHOP_URL_ENDPOINT ?? '';

    // Check if the base URL ends with a slash and remove it if it does
    if (baseUrl.endsWith('/')) {
        baseUrl = baseUrl.slice(0, -1);
    }

    let finalCanonicalUrl = canonical_url;
    // Check if the canonical URL starts with a slash and remove it if it does
    if (canonical_url && canonical_url.startsWith('/')) {
        finalCanonicalUrl = canonical_url.slice(1);
    }

    if (finalCanonicalUrl) {
        return isAbsolute ? `${baseUrl}/${finalCanonicalUrl}` : `/${finalCanonicalUrl}`;
    }
    return isAbsolute ? `${baseUrl}/${createLeadingSlashUrl(url_key!)}${url_suffix}` : `/${url_key}${url_suffix}`;
};
